const [d] = [document];

class Form {
  constructor(){}

  inputInit() {
    const inputs = d.querySelectorAll('\
      input[type="text"].is-required,\
      input[type="email"].is-required,\
      textarea.is-required\
    ');
    const self = this;
    inputs.forEach( item => item.setAttribute('required','true'));

    /****************************
     * 郵便番号検索ボタン
     */
    d.querySelectorAll('[data-plugin=ajaxzip]').forEach( item => {
      item.addEventListener('click', () => {
        AjaxZip3.zip2addr('zip','','addr','addr'); // eslint-disable-line no-undef
        return false;
      });
    });

    
    d.querySelectorAll('input[name="法人/個人"]').forEach( item => {
      item.addEventListener('change', () => self.toggleRequire('法人/個人', '個人', '法人名（団体）'));
    });
    this.toggleRequire('法人/個人', '個人', '法人名（団体）');

  }

  toggleRequire(name,cond,target) {
    $(`.contact-form__name:contains(${target})`).each( (i,v) => {
      const $require = $(v).find('.is-required');
      const $input = $(v).parent().find('input.is-required, textarea.is-required');
      if( $(`input[name="${name}"]:checked`).val() == cond || $(`input[type="hidden"][name="${name}"]`).val() == cond ){
        $require.addClass('d-none');
        $input.removeAttr('required');
      } else {
        $require.removeClass('d-none');
        $input.attr('required');
      }
    })
  }
}

export default function () {
  const FORM = new Form();
  switch( location.pathname ){
    case '/contact/': d.addEventListener('DOMContentLoaded', () => FORM.inputInit() ); break
  }
  
}